import { Avatar, Dropdown, Space, Typography } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth, effectiveRole } from '../auth';
import { CampanaNotificaciones } from '../components';

const { Text } = Typography;

const ROLE_LABEL: Record<string, string> = {
  AdminGlobal: 'Admin',
  Contador:    'Contador',
  Cliente:     'Cliente',
};

export function Topbar() {
  const { user, signOut } = useAuth();
  const role = effectiveRole(user);

  return (
    <Space size="middle">
      {user && <CampanaNotificaciones />}
      {user && (
        <Text type="secondary" style={{ fontSize: 13 }}>
          {role ? ROLE_LABEL[role] : ''}
        </Text>
      )}
      <Dropdown
        placement="bottomRight"
        menu={{
          items: [
            {
              key: 'logout',
              icon: <LogoutOutlined />,
              label: 'Cerrar Sesión',
              onClick: signOut,
            },
          ],
        }}
      >
        <Space style={{ cursor: 'pointer' }}>
          <Avatar icon={<UserOutlined />} size="small" />
          <Text style={{ fontSize: 13 }}>{user?.email}</Text>
        </Space>
      </Dropdown>
    </Space>
  );
}
